// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import PathSummaryHeader from './PathSummaryHeader'

// NOTE - if you're looking for the 'band' heading,
// go to SiteNameHeader.js

class ProjectPathInfoHeader extends PathSummaryHeader {
  pathIndexStyle = {
    marginRight: '8px',
    paddingLeft: '8px',
    width: '30px',
  }

  wrapperStyle = { paddingLeft: 0 }

  sortByIndex = e => this.assignSort(e, 'pathIndex')
  sortByProjectName = e => this.assignSort(e, 'projectName')

  render () {
    const {
      pathIndexStyle,
      props: { idRoot },
      sortByIndex,
      sortByProjectName,
      sortIcon,
      wrapperStyle,
    } = this

    return (
      <div
        className={'display-flex'}
        style={wrapperStyle}>
        <span
          className={'path-summary-heading-trigger-index position-relative padding-half'}
          id={`${idRoot}path-index`}
          onClick={sortByIndex}
          style={pathIndexStyle}>
          {'#'}
          {sortIcon('pathIndex')}
        </span>
        <span
          className={'path-summary-heading-trigger-path-name position-relative padding-half padding-right-1 path-summary-heading-path-name'}
          id={`${idRoot}project-name`}
          onClick={sortByProjectName}>
          {'Project'}
          {sortIcon('projectName')}
        </span>
      </div>
    )
  }
}

export default ProjectPathInfoHeader
